Checklist = require 'models/checklist'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'

module.exports = class ChecklistList extends CollectionWithHelpers
  model: Checklist
  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (checklist) ->
    checklist.get('pos')

  idList: -> @pluck('id')



// WEBPACK FOOTER //
// ./app/scripts/models/collections/checklist-list.coffee